import { wrapView } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { PROJECT_NAME } from "./constants"
import { SigurListView } from '../lib/SigurListView'
import { SigurModalOrderColumn } from '../common_components/modal_order_column'

class ListView extends SigurListView {
    renderModals() {
    let modals = [
      <SigurModalOrderColumn project_name={this.project_name}
      attrs={this.props.attrs}
      table_headers={this.props.table_headers}
      user_table_headers={this.props.user_table_headers} />
    ]


    return [...modals, ...(super.renderModals() || [])]
  }
}

export default wrapView(ListView, (state) => {
  return stateToProps(state, PROJECT_NAME)
})
